import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles({
  styledLink: {
    '&, &:hover, &:focus, &:active': {
      textDecoration: 'none',
      color: colors.blue.l45,
      outline: 0,
      display: 'block',
    },
    '&:focus-visible': {
      boxShadow: `0px 0px 0px 2px ${colors.blue.l50}`,
    },
    '&> p': {
      fontSize: '14px !important',
      lineHeight: '20px',
      fontWeight: '400 !important' as any,
      whiteSpace: 'nowrap',
    },
  },
});
